export default __webpack_public_path__ + "static/media/grafema_amcc_09.119b5da3.jpg";